import { render } from "./MenuUnderline.vue?vue&type=template&id=ef27b9fa&scoped=true"
import script from "./MenuUnderline.vue?vue&type=script&lang=js"
export * from "./MenuUnderline.vue?vue&type=script&lang=js"

import "./MenuUnderline.vue?vue&type=style&index=0&id=ef27b9fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef27b9fa"]])

export default __exports__